import WaveformWorker from 'worker-loader?inline=no-fallback!./worker/waveformWorker';
import TranscriptWorker from 'worker-loader?inline=no-fallback!./worker/transcriptWorker';
import { ColdPromise, guid } from '#/worker/toolkit';

class Task {
  constructor(method, payload) {
    this.method = method;
    this.payload = payload;
    this.taskId = guid();
    this.promise = new ColdPromise();
    this.timing = {
      created: Date.now(),
      mainSent: 0,
      threadReceived: 0,
      threadSent: 0,
      mainReceived: 0,
    };
  }

  run(w) {
    const handler = (e) => {
      if (e.data.taskId === this.taskId) {
        w.removeEventListener('message', handler);
        this.timing = e.data.timing;
        this.timing.mainReceived = Date.now();
        this.promise.resolve(e.data.result);
      }
    };
    w.addEventListener('message', handler);
    this.timing.mainSent = Date.now();
    w.postMessage({
      taskId: this.taskId,
      method: this.method,
      payload: this.payload,
      timing: this.timing,
    });
  }
}

class TimemachineTaskManager {
  constructor() {}

  terminate() {
    this.waveformWorker.terminate();
    this.transcriptWorker.terminate();
  }

  initialize() {
    this.waveformWorker = new WaveformWorker();
    this.transcriptWorker = new TranscriptWorker();
  }

  loadJson(payload) {
    const task = new Task('loadJson', payload);
    task.run(this.waveformWorker);
    return task.promise;
  }

  renderTranscript(payload) {
    const task = new Task('transcript', payload);
    // task.promise.then(() => {
    //   const time = {
    //     idle: task.timing.mainSent - task.timing.created,
    //     took: task.timing.threadSent - task.timing.threadReceived,
    //     total: task.timing.mainReceived - task.timing.mainSent,
    //   };
    //   console.log(`Task[${task.method}]`, time.total, time.took);
    // });
    task.run(this.transcriptWorker);
    return task.promise;
  }

  renderWaveform(payload) {
    const task = new Task('waveform', payload);
    // task.promise.then(() => {
    //   const time = {
    //     idle: task.timing.mainSent - task.timing.created,
    //     took: task.timing.threadSent - task.timing.threadReceived,
    //     total: task.timing.mainReceived - task.timing.mainSent,
    //     parse: task.timing.parse,
    //     draw: task.timing.draw,
    //   };
    //   console.log(`Task[${task.method}]`, time.total, ~~time.draw);
    // });
    task.run(this.waveformWorker);
    return task.promise;
  }
}

export default new TimemachineTaskManager();
